<template>
  <list-template :classCustom="'list-job'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              <h3 class="font-weight__bold">
                Báo cáo trung bình tháng đánh giá nhân viên
              </h3>
            </div>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <el-form
                  ref="form"
                  :model="form"
                  label-position="top"
                  class="input-no__label"
                >
                  <el-row :gutter="24" class="leftSection margin-right-10">
                    <el-col
                      :span="14"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto">Đơn vị</span>
                      <el-select
                        v-model="form.deptId"
                        class="style-fullWidth input-none__border has-border__bottom"
                        size="medium"
                      >
                        <el-option
                          v-for="item in departments"
                          :key="item.id"
                          :label="item.deptName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col
                      :span="8"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto">Tháng</span>

                      <el-date-picker
                        v-model="dateRange"
                        type="monthrange"
                        format="MM/yyyy"
                        class="style-fullWidth  input-border__bottom input-border__radius__0"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        size="large"
                        @change="dateRangeChanged"
                      ></el-date-picker>
                    </el-col>

                    <el-col
                      :span="2"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <el-button
                        class="btnSolid__blue"
                        size="medium"
                        @click="exportReport"
                      >
                        <i class="fa fa-table" aria-hidden="true"></i>
                        &nbsp;Xem báo cáo
                      </el-button>

                      <el-button
                        class="btnSolid__blue"
                        size="medium"
                        @click="exportReportExcel"
                      >
                        <i class="fa fa-file-excel" aria-hidden="true"></i>
                        &nbsp;Xuất Excel
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </sub-header>
          </template>
          <template #body>
            <template>
              <div class="barChart" ref="barChartContainerDiv">
                <ranking-report-common-table
                  ref="reportTable"
                  @viewDetail="viewDetail"
                ></ranking-report-common-table>
              </div>
            </template>
          </template>
        </list-template>
      </div>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from "../../common/list";
import MainHeader from "../../../components/header/main-header";
import utils from "../../../services/utils";
import constants from "../../../constants";
import SubHeader from "../../../components/main/sub-header";
import departmentService from "../../../services/departmentService";
import dateFormatter from "../../../filters/dateFormatter";
import moment from "moment-business-days";
import rankingReportService from "../../../services/rankingReportService";
import RankingReportCommonTable from "./ranking-report-common-table";
import dateUtils from "../../../dateUtils";

export default {
  name: "ranking-bao-cao-tong-hop-thang",
  components: {
    RankingReportCommonTable,
    SubHeader,
    MainHeader,
    ListTemplate
  },

  filters: {dateFormatter},

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  data() {
    return {
      form: {
        fromDate: null,
        toDate: null,
        deptId: null
      },
      dateRange: null,
      departments: null,
      reportResult: null,
      dateQuickFilterOption: null
    };
  },

  watch: {
    reportResult(newValue) {
      if (this.$refs.reportTable)
        this.$refs.reportTable.renderTable({reportResult: newValue});
    }
  },

  created() {
    if (!this.userDeptRole) return;
    this.initDateQuickFilterOption();
    this.initQuery();
    this.loadDepartments();
    this.exportReport();
  },

  methods: {
    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    dateRangeChanged() {
      this.form.fromDate =
        this.dateRange && this.dateRange[0]
          ? this.dateRange[0].getTime()
          : undefined;
      this.form.toDate =
        this.dateRange && this.dateRange[1]
          ? this.dateRange[1].getTime()
          : undefined;
      this.initDateRange();
    },

    initDateRange() {
      if (this.form.fromDate && this.form.toDate) {
        this.dateRange = [
          dateUtils.toMoment(this.form.fromDate).toDate(),
          dateUtils.toMoment(this.form.toDate).toDate()
        ];
      } else {
        this.dateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        this.form.fromDate = defaultTimeRange[0];
        this.form.toDate = defaultTimeRange[1];
      }
    },

    viewDetail(event) {
      let item = event.item;
      let filterForm = this.convertToFilterForm();
      let toDate = moment(filterForm.endDate)
        .add(-1, "days")
        .toDate()
        .getTime();
      let query = {
        deptId: filterForm.deptId,
        userDeptRoleId: item.userDeptRoleView.id,
        fromDate: filterForm.startDate,
        toDate: toDate
      };
      this.$router.push({
        name: "rankingScoreIndex",
        params: this.$route.params,
        query: query
      });
    },

    loadDepartments() {
      return departmentService
        .findAllCurrentAndIncludeSubDepts()
        .then(response => (this.departments = response.data));
    },

    initQuery() {
      this.form.fromDate = this.$route.query.fromDate
        ? parseInt(this.$route.query.fromDate)
        : undefined;
      this.form.toDate = this.$route.query.toDate
        ? parseInt(this.$route.query.toDate)
        : undefined;
      this.form.deptId = this.$route.query.deptId || this.userDeptRole.deptId;
      this.initDateRange();
    },

    buildQuery() {
      return {
        fromDate: this.form.fromDate || undefined,
        toDate: this.form.toDate || undefined,
        deptId: this.form.deptId || undefined
      };
    },

    validate() {
      return new Promise(resolve => {
        if (!this.form.deptId) {
          this.$message({
            message: "Đơn vị bắt buộc nhập",
            type: "error"
          });
          return;
        }
        let diff;
        if (!this.form.fromDate || !this.form.toDate) {
          this.$message({
            message: "Khoảng thời gian (từ ngày/đến ngày) bắt buộc nhập",
            type: "error"
          });
          return;
        }
        let fromDate = dateUtils.toMoment(this.form.fromDate);
        let toDate = dateUtils.toMoment(this.form.toDate);
        diff = toDate.diff(fromDate, "day");
        if (diff < 0) {
          this.$message({
            message: "Trường Đến ngày không được nhỏ hơn trường tới ngày",
            type: "error"
          });
          return;
        }
        if (diff > 365) {
          this.$message({
            message: "Khoảng thời gian phải nhỏ hơn 1 năm",
            type: "error"
          });
          return;
        }
        resolve();
      });
    },

    storeParamsAtUrl() {
      let query = this.buildQuery();
      let routerQuery = utils.merge(this.$route.query || {}, query);
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: routerQuery
      });
    },

    convertToFilterForm() {
      let startDate = moment(this.form.fromDate)
        .startOf("month")
        .toDate();
      let endDate = moment(this.form.toDate)
        .add(1, "months")
        .startOf("month")
        .toDate();

      return {
        startDate: startDate.getTime(),
        endDate: endDate.getTime(),
        deptId: this.form.deptId
      };
    },

    exportReport() {
      return this.validate().then(() => {
        this.storeParamsAtUrl();
        return rankingReportService
          .trungBinhThangReport(this.convertToFilterForm())
          .then(response => (this.reportResult = response.data));
      });
    },

    exportReportExcel() {
      this.exportReport().then(() => {
        let query = utils.merge(this.convertToFilterForm(), {userDeptRoleId: this.userDeptRoleId});
        let baseServiceURL = constants.BASE_SERVICE_URL;
        let reportUrl = constants.REPORT.QLCV.URL.RANKING_TRUNGBINHTHANGREPORT;
        window.open(
          `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
          "_blank "
        );
      });
    }
  }
};
</script>

<style scoped>
.barChart {
  margin-top: 20px;
  height: calc(100% - 100px) !important;
  width: calc(100% - 10px) !important;
  position: relative;
}

.break-word {
  word-break: break-word;
}

.ranking-gold {
  color: gold;
}

.ranking-silver {
  color: silver;
}

.ranking-bronze {
  color: darkorange;
}
</style>



// WEBPACK FOOTER //
// src/views/report/ranking/ranking-bao-cao-trung-binh.vue